import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const clients = [
  { name: "Zepto", file: "zepto.svg", width: 110 },
  { name: "Zomato", file: "zomato.svg", width: 130 },
  { name: "Blue Dart", file: "blue-dart.svg", width: 150 },
  { name: "Uber", file: "uber.svg", width: 90 },
  { name: "Amazon", file: "amazon.svg", width: 120 },
  { name: "Flipkart", file: "flipkart.svg", width: 120 },
];

export default function ClientsSection() {
  return (
    <Box component="section" sx={{ py: { xs: 7, md: 9 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Box
            sx={{
              display: "inline-block",
              px: 2,
              py: 0.6,
              borderRadius: "20px",
              bgcolor: "rgba(114, 191, 32, 0.12)",
              color: "secondary.dark",
              fontSize: 12.5,
              fontWeight: 700,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              mb: 1.5,
            }}
          >
            TRUSTED BY LEADING COMPANIES
          </Box>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: { xs: 26, md: 34 },
              fontWeight: 700,
              color: "text.primary",
              letterSpacing: "-0.02em",
            }}
          >
            We provide electric mobility solutions for some of{" "}
            <Box component="span" sx={{ color: "primary.main" }}>
              India's fast-growing companies.
            </Box>
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 2.5, md: 3.5 }} justifyContent="center" alignItems="stretch">
          {clients.map((client) => (
            <Grid item xs={6} sm={4} md={2} key={client.name}>
              <Box
                sx={{
                  height: { xs: 84, md: 96 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "background.default",
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: "14px",
                  px: 2.5,
                  transition: "all 0.25s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 28px -12px rgba(27, 78, 216, 0.15)",
                    borderColor: "secondary.main",
                    bgcolor: "background.paper",
                  },
                  "&:hover img": {
                    filter: "none",
                    opacity: 1,
                  },
                }}
              >
                <Box
                  component="img"
                  src={`/assets/images/clients/${client.file}`}
                  alt={`${client.name} logo`}
                  sx={{
                    width: "100%",
                    maxWidth: client.width,
                    height: "auto",
                    display: "block",
                    filter: "grayscale(100%)",
                    opacity: 0.7,
                    transition: "filter 0.25s ease, opacity 0.25s ease",
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
